import {
  GET_CAMPAIGN,
  GET_CAMPAIGN_APPLICATIONS_PROFILE_LIST,
  GET_CAMPAIGN_CLIENTS_PROFILE_LIST,
  GET_CAMPAIGN_DIRECTION_TYPE_PROFILE_LIST,
  GET_CAMPAIGN_FORMAT_PROFILE_LIST,
  GET_CAMPAIGN_MEDIA_BUYER_PROFILE_LIST,
  GET_CAMPAIGN_OFFER_TYPE_PROFILE_LIST,
  GET_CAMPAIGN_SOURCE_PROFILE_LIST,
  GET_CAMPAIGN_STATUS_PROFILE_LIST,
  SET_CAMPAIGN,
  SET_CAMPAIGN_APPLICATIONS_PROFILE_LIST,
  SET_CAMPAIGN_CLIENTS_PROFILE_LIST,
  SET_CAMPAIGN_DIRECTION_TYPE_PROFILE_LIST,
  SET_CAMPAIGN_ERROR,
  SET_CAMPAIGN_FORMAT_PROFILE_LIST,
  SET_CAMPAIGN_MEDIA_BUYER_PROFILE_LIST,
  SET_CAMPAIGN_OFFER_TYPE_PROFILE_LIST,
  SET_CAMPAIGN_SOURCE_PROFILE_LIST,
  SET_CAMPAIGN_STATUS_PROFILE_LIST,
  UPDATE_CAMPAIGN_PROFILE
} from "./actionTypes";

export const getCampaign = id => ({
  type: GET_CAMPAIGN,
  payload: id
})

export const setCampaign = payload => ({
  type: SET_CAMPAIGN,
  payload
})

export const setCampaignError = payload => ({
  type: SET_CAMPAIGN_ERROR,
  payload
})

export const getAllCampaignClientList = () => ({
  type: GET_CAMPAIGN_CLIENTS_PROFILE_LIST,
})

export const setCampaignClientList = payload => ({
  type: SET_CAMPAIGN_CLIENTS_PROFILE_LIST,
  payload
})

export const getAllCampaignAppsList = () => ({
  type: GET_CAMPAIGN_APPLICATIONS_PROFILE_LIST,
})

export const setCampaignAppsList = payload => ({
  type: SET_CAMPAIGN_APPLICATIONS_PROFILE_LIST,
  payload
})

export const getAllCampaignOfferTypeProfileList = () => ({
  type: GET_CAMPAIGN_OFFER_TYPE_PROFILE_LIST,
})

export const setCampaignOfferTypeProfileList = payload => ({
  type: SET_CAMPAIGN_OFFER_TYPE_PROFILE_LIST,
  payload
})

export const getAllCampaignSourceProfileList = () => ({
  type: GET_CAMPAIGN_SOURCE_PROFILE_LIST,
})

export const setCampaignSourceProfileList = payload => ({
  type: SET_CAMPAIGN_SOURCE_PROFILE_LIST,
  payload
})

export const getAllCampaignDirectionTypeProfileList = () => ({
  type: GET_CAMPAIGN_DIRECTION_TYPE_PROFILE_LIST,
})

export const setCampaignDirectionTypeProfileList = payload => ({
  type: SET_CAMPAIGN_DIRECTION_TYPE_PROFILE_LIST,
  payload
})

export const getAllCampaignStatusProfileList = () => ({
  type: GET_CAMPAIGN_STATUS_PROFILE_LIST,
})

export const setCampaignStatusProfileList = payload => ({
  type: SET_CAMPAIGN_STATUS_PROFILE_LIST,
  payload
})

export const getAllCampaignMediaBuyerProfileList = () => ({
  type: GET_CAMPAIGN_MEDIA_BUYER_PROFILE_LIST,
})

export const setCampaignMediaBuyerProfileList = payload => ({
  type: SET_CAMPAIGN_MEDIA_BUYER_PROFILE_LIST,
  payload
})

export const getAllCampaignFormatProfileList = () => ({
  type: GET_CAMPAIGN_FORMAT_PROFILE_LIST,
})

export const setCampaignFormatProfileList = payload => ({
  type: SET_CAMPAIGN_FORMAT_PROFILE_LIST,
  payload
})

export const updateCampaignProfile = (id, profile = {}, data = {}) => ({
  type: UPDATE_CAMPAIGN_PROFILE,
  payload: {id, profile, data }
})